import { useConnection } from "@solana/wallet-adapter-react";
import { PublicKey } from "@solana/web3.js";
import { MARKETPLACE_PROGRAM_ID } from "@stepfinance/dex";
import { ContextButton } from "@stepfinance/react";
import type { FC } from "react";
import { useCallback } from "react";

import { useLanguageContext } from "../../../../contexts/language/language";
import { gmClientService } from "../../../../hooks/dex/useStarAtlasOrders";
import { useConnectedWallet } from "../../../../hooks/wallet/useConnectedWallet";
import { sendTransaction } from "../../../../utils/transactions";

type CloseSAOrderButtonProps = {
  orderId: string;
};

export const CloseSAOrderButton: FC<CloseSAOrderButtonProps> = ({ orderId }) => {
  const wallet = useConnectedWallet();
  const { connection } = useConnection();

  const {
    currentLanguageData: {
      common,
      pages: {
        dashboard: {
          modules: { DEXModule },
        },
      },
    },
  } = useLanguageContext();

  const closeOrder = useCallback(async () => {
    if (wallet && wallet.publicKey) {
      const { transaction, signers } = await gmClientService.getCancelOrderTransaction(
        connection,
        new PublicKey(orderId),
        wallet.publicKey,
        MARKETPLACE_PROGRAM_ID,
      );
      await sendTransaction(connection, wallet, transaction.instructions, signers, true, undefined, true, {
        inProgress: {
          message: DEXModule.notifications.cancellingOrder.message,
          description: common.notifications.transactionInProgress,
        },
        success: {
          message: DEXModule.notifications.cancelledOrder.message,
          description: "",
        },
      });
    }
  }, [
    DEXModule.notifications.cancelledOrder.message,
    DEXModule.notifications.cancellingOrder.message,
    common.notifications.transactionInProgress,
    connection,
    orderId,
    wallet,
  ]);

  return (
    <ContextButton
      onClick={(e) => {
        e.stopPropagation();
        void closeOrder();
      }}
    >
      {DEXModule.buttons.cancel}
    </ContextButton>
  );
};
